/* eslint-disable no-use-before-define */

import { Chip } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { Fragment } from 'react';
import { getEnvVariable } from '../../../modules/environmentalList';
import DefaultSettings from './settings';
import Typography from '@material-ui/core/Typography';
const _ = require('lodash');
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const defaults = {
    transformProps: {
        label: 'Name',
        value: 'Id'
    }
}

export default function CheckboxesTags(props) {
    const { value, handleFieldValue, extraProps, shareProps, error, required, tooltip, ismulti, contexthelp, changefieldto, limitTags, ...otherProps } = props
    const { label, helperText, items, name, fullWidth, disabled, defaultProperty } = otherProps
    let { transformProps } = extraProps || {}
    transformProps = transformProps || defaults.transformProps
    let val = (value === undefined || value === null) ? '' : value;
    let valarray = []
    if (val !== '' && items && items.length > 0) {
        if (ismulti || changefieldto === 'DM') {
            val = val && val.split(',')
            items.sort((a, b) => val.indexOf(a) - val.indexOf(b));
            valarray = items.filter(function (item) {
                if (item[transformProps.value])
                    return val.indexOf((item[transformProps.value]).toString()) > -1
                else return false
            });
            valarray.sort(function (a, b) {
                return val.indexOf(a[transformProps.value]) - val.indexOf(b[transformProps.value]);
            });
        }
        else {
            valarray = items.filter(item => { return item[transformProps.value] === val })

        }
    }
    else if (val === '' && items && items.length > 0 && defaultProperty && ismulti) {
        valarray = items.filter(item => { return item[defaultProperty.name] === defaultProperty.value })
        const defaultVals = valarray.map(item => item[transformProps.value]).join(',');
        handleFieldValue({
            target: {
                name: name, value: defaultVals, checked: false
            }, currentTarget: { dataset: null }
        })
    }


    // let tlabel = (tooltip || contexthelp) ? <Fragment> {label} < Tooltip title={tooltip ? tooltip : null} placement="bottom-start" >
    //     <HelpOutlineIcon fontSize="small" style={{ width: '0.8em', color: getEnvVariable('ModuleKey') == 'AEPS' ? "#00355f" : '#007bff'}} onClick={() => DefaultSettings.showDrawer(contexthelp)} />
    // </Tooltip> </Fragment> : label;
    let tlabel = <Typography variant={(valarray && valarray.length > 0) ? 'h6' : 'caption'} color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
        {tooltip && <Tooltip title={tooltip ? tooltip : null}
            placement="bottom-start" >
            <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
                onClick={(evt) => contexthelp ?
                    DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
        </Tooltip>}
    </Typography>
    return (

        <Autocomplete
            //style={{ width: '50%' }}
            label={tlabel}
            helperText={helperText}
            fullWidth={fullWidth ? fullWidth : true}
            error={error}
            //required={required}
            multiple={ismulti || changefieldto === 'DM'}
            disabled={disabled || false}
            limitTags={limitTags || 2}
            value={valarray}
            {...otherProps}
            options={items && Array.isArray(items) ? items : []}
            disableCloseOnSelect
            getOptionLabel={(option) => option[transformProps.label]}
            onChange={(event, option) => handleFieldValue({
                target: {
                    name: name, value: (ismulti || changefieldto === 'DM') ?
                        (_.map(option, transformProps.value)).join(',') : (option && option[transformProps.value]) || null, checked: false
                }, currentTarget: { dataset: null }
            })}
            renderOption={(option, { selected }) => (
                <React.Fragment>
                    <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    {option[transformProps.label]}
                </React.Fragment>
            )}
            renderTags={(value, getTagProps) =>
                valarray.map((option, index) => (
                    <Chip variant="outlined" size='small' label={option[transformProps.label]} {...getTagProps({ index })} />
                ))
            }
            //  renderTags={() => null} 
            renderInput={params => (
                <TextField
                    disabled={disabled || false}
                    style={{ minHeight: '50px', overflowY: 'auto', overflowX: 'hidden' }}
                    {...params}
                    label={tlabel}
                    helperText={helperText}
                    error={error}
                    // required={required}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {/* {loading ? <CircularProgress color="inherit" size={20} /> : null} */}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                // InputLabelProps={{
                //     shrink: true,
                // }}
                // InputLabelProps={{
                //     shrink: true,
                // }}
                />
            )}
        />

        // </FormControl>
    )
}

// <FormControl>
{/* <InputLabel style={{ fontWeight: 'bold', color: error ? 'red' : 'black' }} shrink> {label} {tooltip && <Tooltip title={tooltip ? tooltip : null}
                placement="bottom-start" >{contexthelp && <HelpOutlineIcon fontSize="small" style={{ width: '0.8em', color: getEnvVariable('ModuleKey') == 'AEPS' ? "#00355f" : '#007bff' }} onClick={(evt) => contexthelp ?
                    DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />}
            </Tooltip>} </InputLabel> */}
{/* <div className="mb-1" /> */ }